module.exports = __webpack_public_path__ + "static/media/icon-triagem.9fa1b527.svg";